export default "__VITE_ASSET__DrRyt1Du__"